import { useAppConfig } from '../hooks/useAppConfig';
import { AuthApi as CoreAuthApi } from '@mc/react-auth';
import { baseAxios } from '@mc/axios-api';

const appConfig = useAppConfig();

export const AuthApi = new CoreAuthApi(
  { baseURL: appConfig.serverContextPath },
  baseAxios
);
